module.exports = __webpack_public_path__ + "media/images/emblems/Moehlin-blason-cc2babb70c603d1aab91748037fae4f9.png";